import { UserRoles } from 'Contexts/User/UserContext';

export const allEventEditRoles: UserRoles[] = ['Admin'];

export const allEventViewRoles: UserRoles[] = ['EventHead'];

export const specificEventViewRoles: UserRoles[] = ['User'];
